import { createContext } from "react";
import { IDialogProps } from "./IDialogPropsTypes";

export const DialogServiceContext = createContext<{
  show: ((props: IDialogProps) => Promise<unknown>) | (() => void);
}>({ show: () => {} });
